<template>
	<div class="finance-container finance-wrap">
		<!-- 供应商搜索 -->
		<div class="account-search">
			<DateRangePicker style="width: 400px;" :startDate.sync="query.startDate" :endDate.sync="query.endDate">
			</DateRangePicker>
			<el-input v-model="query.name" placeholder="订单号" clearable style="width: 300px; margin-right: 10px;"></el-input>
			<el-select filterable clearable v-model="query.status" placeholder="开票状态" style="width: 300px;">
				<el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
			</el-select>
			<el-input v-model="query.customerName" placeholder="客户名称" clearable
				style="width: 300px; margin-right: 10px;"></el-input>
			<div class="box-input-btn">
				<el-button class="default" @click="initQuery">查询</el-button>
			</div>
			<div class="box-input-btn" style="margin-left: auto;">
			</div>
		</div>

		<div style="display: flex; justify-content: space-between; align-items: center;">
			<div class="status-container">
				<div class="status-item status-all" :class="{ 'active': query.status == null }" @click="setActiveStatus(null)">
					全部{{ dataCount.totalCount }}
				</div>
				<div class="status-item status-pending" :class="{ 'active': query.status === 0 }" @click="setActiveStatus(0)">
					待开票{{ dataCount.waitCount }}
				</div>
				<div class="status-item status-paid" :class="{ 'active': query.status === 1 }" @click="setActiveStatus(1)">
					已开票{{ dataCount.invoicedCount }}
				</div>
			</div>
		</div>
		<!-- 账户列表 -->
		<el-table :data="accountList"
			:header-cell-style="{ backgroundColor: '#F2F4F7', color: '#333', fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }"
			style="width: 100%" :height="'570px'" :cell-style="{ 'text-align': 'center' }">
			<el-table-column prop="userName" label="开票申请人">
			</el-table-column>
			<el-table-column prop="amount" label="开票金额">
			</el-table-column>
			<el-table-column prop="url" label="快照">
				<template slot-scope="scope">
					<el-image v-if="scope.row.url" :src="scope.row.url" fit="fill" :preview-src-list="[scope.row.url]"
						style="width: 50px; height: 50px;"></el-image>
					<span v-else>无</span>
				</template>
			</el-table-column>
			<el-table-column prop="oUserName" label="审核人">
			</el-table-column>
			<el-table-column prop="statusName" label="审核状态">
				<template slot-scope="scope">
					<span v-if="scope.row.status == 1" class="status-tag-solid approved">{{ scope.row.statusName
					}}</span>
					<span v-else-if="scope.row.status == -1" class="status-tag-solid failed">{{ scope.row.statusName
					}}</span>
					<span v-else class="status-tag-solid pending">{{ scope.row.statusName }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="createdTime" label="开票时间">
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<!-- <el-button type="text" size="small">支出</el-button>
                    <el-button type="text" size="small">查看明细</el-button> -->
					<el-button v-if="scope.row.status == 0" type="text" size="small"
						@click="openAddAccountDialog('审核', scope.row)">审核</el-button>
					<el-button v-else type="text" size="small" @click="handleDelete(scope.row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="table-pagination">
			<el-pagination @current-change="currentChange" :current-page="query.page" :page-size="query.pageSize"
				layout="total, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

		<!-- 提示信息 -->
		<!-- <div class="tips">
            <span style="color: #F56C6C;">删除只能删除无流水账户</span>
        </div>
        <div class="tips">
            <span>双击编辑文本</span>
        </div> -->

		<!-- 添加账户对话框 -->
		<el-dialog :title="title" :visible.sync="addAccountDialogVisible" width="500px">
			<el-form ref="addAccountFormRef" :model="addAccountForm" :rules="addAccountRules" label-width="100px">
				<el-form-item label="开票申请人" prop="userName">
					<div>{{ addAccountForm.userName }}</div>
				</el-form-item>
				<el-form-item label="开票金额" prop="amount">
					<div>{{ addAccountForm.amount }}</div>
				</el-form-item>
				<el-form-item label="审核状态" prop="status">
					<el-radio-group v-if="!addAccountForm.isView" v-model="addAccountForm.status"
						:disabled="addAccountForm.isView">
						<el-radio :label="1">通过</el-radio>
						<el-radio :label="2">取消</el-radio>
					</el-radio-group>
					<div v-else style="height: 24px;">
						<span v-if="addAccountForm.status == 1" class="status-tag-solid approved">开票成功</span>
						<span v-else-if="addAccountForm.status == -1" class="status-tag-solid failed">已取消</span>
						<span v-else class="status-tag-solid pending">待开票</span>
					</div>
				</el-form-item>
				<el-form-item label="审核快照" prop="url">
					<upload v-if="!addAccountForm.isView" v-model="addAccountForm.url" accept="img" :auto-upload="true"
						:image-url="addAccountForm.url" :drag="'drag'" thisType="custom" @input="toImg($event, 'url')"
						:customSty="{ width: '320px', height: '154px' }">
					</upload>
					<el-image v-else-if="addAccountForm.url" :src="addAccountForm.url" fit="fill"
						:preview-src-list="[addAccountForm.url]" style="width: 320px;"></el-image>
					<span v-else>无</span>
				</el-form-item>
				<el-form-item label="备注" prop="auditReMarks">
					<el-input type="textarea" v-if="!addAccountForm.isView" :rows="4" v-model="addAccountForm.auditReMarks"
						placeholder="请输入备注"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addAccountDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveAddAccount" v-if="!addAccountForm.isView">保存</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { addsupplier, querysupplier, updatesupplier, deletesupplier } from '@/api/finance';
import DateRangePicker from '@/components/DateRangePicker.vue';
import { queryorderorg, orderinvoiceaudit } from '@/api/order';
import upload from '@/components/upload.vue';
export default {
	components: {
		DateRangePicker
	},
	data() {
		return {
			addAccountDialogVisible: false,
			dataCount: {
				totalAmount: 0,
				totalCount: 0,
				waitAmount: 0,
				waitCount: 0,
				invoicedCount: 0,
				total: 0
			},
			statusList: [
				{ value: 0, label: '待开票' },
				{ value: 1, label: '已开票' },
				{ value: -1, label: '已取消' },
			],
			query: {
				name: '',
				startDate: '',
				endDate: '',
				page: 1,
				pageSize: 10,
				status: null,
				customerName: ''
			},
			addAccountForm: {
			},
			addAccountRules: {
				status: [
					{ required: true, message: '请选择审核状态', trigger: 'blur' }
				],
				url: [
					{ required: true, message: '请上传审核快照', trigger: 'blur' }
				]
			},
			accountList: [],
			accountListAll: [],
			title: '添加账户',
			total: 0,
			accountTotalData: {
				total: 0,
				receivable: 0
			}
		}
	},
	methods: {
		setActiveStatus(status) {
			this.query.status = status;
			this.query.page = 1;
			this.getQueryaccountList();
		},
		openAddAccountDialog(title, item = {}) {
			this.addAccountForm = {
				id: item.id,
				status: '',
				url: "",
				auditReMarks: "",
				userName: item.userName,
				amount: item.amount,
			}
			this.addAccountDialogVisible = true;
			this.title = title;
		},
		saveAddAccount() {
			// 表单校验
			this.$refs.addAccountFormRef.validate((valid) => {
				if (valid) {
					// 保存逻辑
					console.log('保存数据:', this.addAccountForm);
					orderinvoiceaudit(this.addAccountForm).then(res => {
						if (res.code == 1) {
							this.$message({
								message: '审核成功',
								type: 'success'
							});
							this.query.page = 1;
							this.getQueryaccountList();
							// 关闭对话框
							this.addAccountDialogVisible = false;
							// 重置表单
							this.addAccountForm = {
								id: "",
								status: '',
								url: "",
								auditReMarks: "",
								userName: "",
								amount: "",
							}
						}
					})
				} else {
					return false;
				}
			});
		},
		editAccount() {
			updatesupplier(this.addAccountForm).then(res => {
				if (res.code == 1) {
					this.$message({
						message: '编辑成功',
						type: 'success'
					});
					this.query.page = 1;
					this.getQueryaccountList();
					// 关闭对话框
					this.addAccountDialogVisible = false;
					// 重置表单
					this.addAccountForm = {
						name: "",
						contact: "",
						phone: "",
						accountInfo: ""
					};
				}
			})
		},
		createAccount() {
			addsupplier(this.addAccountForm).then(res => {
				if (res.code == 1) {
					this.$message({
						message: '添加成功',
						type: 'success'
					});
					this.query.page = 1;
					this.getQueryaccountList();
					// 关闭对话框
					this.addAccountDialogVisible = false;
					// 重置表单
					this.addAccountForm = {
						name: '',
						balance: '',
						remark: ''
					};
				}
			})
		},
		getQueryaccountList() {
			queryorderorg({
				"Key": this.query.name,
				"StartDate": this.query.startDate,
				"EndDate": this.query.endDate,
				"Status": this.query.status,
				"Page.Index": this.query.page,
				"Page.Size": this.query.pageSize,
				"CustomerName": this.query.customerName
			}).then(res => {
				this.accountList = res.data.rows;
				this.total = res.data.total;
				for (let key in this.dataCount) {
					this.dataCount[key] = res.data[key];
				}
			})
		},
		currentChange(value) {
			this.query.page = value;
			this.getQueryaccountList();

		},
		handleFeeInput() {
			// 只允许输入数字
			this.addAccountForm.fee = this.addAccountForm.fee.toString().replace(/[^0-9.]/g, '');
		},
		handleBalanceInput() {
			// 只允许输入数字
			let value = this.addAccountForm.balance.toString().replace(/[^0-9.]/g, '');
			// 处理小数
			if (value.includes('.')) {
				// 如果有小数点，确保只有两位小数
				const parts = value.split('.');
				if (parts.length > 2) {
					value = parts[0] + '.' + parts[1].substring(0, 2);
				} else if (parts[1] && parts[1].length > 2) {
					value = parts[0] + '.' + parts[1].substring(0, 2);
				}
			}
			this.addAccountForm.balance = value;
		},
		initQuery() {
			this.query.page = 1;
			this.getQueryaccountList();
		},
		handleDelete(item) {
			this.addAccountForm = {
				id: item.id,
				status: item.status,
				url: item.url,
				auditReMarks: item.auditReMarks,
				userName: item.userName,
				amount: item.amount,
				isView: true,
			}
			this.addAccountDialogVisible = true;
			this.title = '查看发票';
		}
	},
	created() {
		this.getQueryaccountList();
		getQueryaccount().then(res => {
			this.accountListAll = res.data.rows;
		})
		getaccounttotal().then(res => {
			this.accountTotalData.total = res.data.total;
			this.accountTotalData.receivable = res.data.receivable;
		})
	}
}
</script>
<style scoped lang="scss">
.finance-container {
	padding: 20px;

	h2 {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 20px;
	}

	.finance-overview {
		display: flex;
		margin-bottom: 20px;
		padding-bottom: 15px;
		border-bottom: 1px solid #e4e7ed;

		.overview-item {
			margin-right: 30px;

			.label {
				font-size: 14px;
				color: #606266;
			}

			.value {
				font-size: 14px;
				color: #303133;
				font-weight: 500;
			}
		}
	}

	.account-search {
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		padding-bottom: 15px;
		border-bottom: 1px solid #e4e7ed;

		.label {
			font-size: 14px;
			color: #606266;
			margin-right: 10px;
		}
	}

	.tips {
		margin-top: 10px;
		font-size: 12px;
		color: #909399;
	}
}

.table-pagination {
	margin-top: 15px;
	text-align: right;
}

.finance-wrap {
	// width: 953px;
	width: calc(100% - 30px);

	::v-deep .el-select {
		margin-right: 5px;
		width: 125px;
	}

	::v-deep .el-input__inner {
		background: #F2F4F7;
		border: none;
	}

	::v-deep .el-table__row {
		.cell {
			font-size: 12px;
		}
	}

	::v-deep .el-date-editor {
		margin-right: 5px;
		width: 240px;

		.el-range-input {
			background: transparent;
		}

		.el-range__close-icon {
			width: 10px;
		}
	}

	.box-table {
		height: calc(100% - 210px) !important;

		::v-deep .el-table__body-wrapper {
			height: 100% !important;
			height: auto !important;
		}
	}

	.box-top {
		width: 593px;
		height: 81px;
		background: #FFFFFF;
		box-shadow: 0px 3px 12px 1px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		padding: 5px 10px;

		.top-item {
			width: 30%;

			p {
				color: #666;
				font-size: 12px;
			}

			.balance {
				color: #333333;
				font-size: 20px;
				font-weight: bold;
			}

			.iconfont {
				vertical-align: middle;
				margin-right: 5px;
			}
		}
	}

}

.box-input-btn {
	text-align: right;

	.box-input-btn-cz {
		background: #EAF3FF;
		color: #3888E9;
		border: none;
	}

	.box-input-btn-add {
		background: #D8F5E4;
		color: #54D8A5;
		border: none;
	}
}

.status-container {
	display: flex;
	margin-top: 20px;
	margin-bottom: 16px;

	.status-item {
		padding: 4px 12px;
		margin-right: 8px;
		border-radius: 4px;
		cursor: pointer;
		transition: all 0.3s;
		font-size: 12px;
		background-color: transparent;

		&.status-all {
			border: 1px solid #409EFF;
			color: #409EFF;

			&.active {
				background-color: #409EFF;
				color: white;
			}
		}

		&.status-pending {
			border: 1px solid #E6A23C;
			color: #E6A23C;

			&.active {
				background-color: #E6A23C;
				color: white;
			}
		}

		&.status-paid {
			border: 1px solid #67C23A;
			color: #67C23A;

			&.active {
				background-color: #67C23A;
				color: white;
			}
		}

		&.status-unpaid {
			border: 1px solid #F56C6C;
			color: #F56C6C;

			&.active {
				background-color: #F56C6C;
				color: white;
			}
		}
	}

}

.status-tag-solid {
	padding: 4px 8px;
	border-radius: 4px;
	font-size: 12px;
	font-weight: 500;

	&.approved {
		background-color: #67C23A;
		color: white;
	}

	&.failed {
		background-color: #F56C6C;
		color: white;
	}

	&.pending {
		background-color: #E6A23C;
		color: white;
	}
}
</style>
